<template>
  <div v-if="result">
    <div class="d1">
      根据当前文本内容进行智能纠错，不可修改文本内容
    </div>
    <SearchInfo
      ref="searchinfo"
      :check="check"
      :percentage="percentage"
      :ptage="ptage"
      :contentCount="contentCount"
      :contentTime="contentTime"
      checkType="error"
      @CheckOver="CheckOver"
    ></SearchInfo>
  </div>
  <div v-else>
    <div v-if="msg.length > 0" id="detection-content" style="overflow:auto">
      <div class="detection-box" v-for="(item, index) in msg" :key="index">
        <div
          class="detection-left"
          v-if="item.replaceStr && item.alertType == 4"
        >
          <span class="detection-text">{{ item.words }}</span>
          <span
            class="detection-subtext cursor"
            @click="
              setDetectionText(
                wycShow ? index : item.index,
                item.words,
                item.replaceStr
              )
            "
            >建议替换为</span
          >
          <span class="detection-text">{{ item.replaceStr }}</span>
        </div>

        <div
          class="detection-left"
          v-if="
            !item.replaceStr && (item.alertType == 4 || item.alertType == 16)
          "
        >
          <span class="detection-text" :title="item.words"
            ><span class="detection-subtext">{{ item.alertMessage }}</span
            >{{ item.words }}</span
          >
        </div>
        <div
          class="detection-left"
          v-if="!item.replaceStr && item.alertType == 3"
        >
          <span class="detection-text" :title="item.words"
            ><span class="detection-subtext">建议：</span>删除 "{{
              item.words
            }}"</span
          >
        </div>
        <div
          class="detection-left"
          v-if="item.alertType == 1 || item.alertType == 2"
        >
          <span class="detection-text" :title="item.words"
            ><span class="detection-subtext">建议：</span>在 "{{
              item.words
            }}"{{ item.alertType == 1 ? "前" : "后" }}新增 "{{
              item.replaceStr
            }}"</span
          >
        </div>
        <div
          class="detection-right"
          v-if="
            (item.replaceStr && item.alertType == 4) ||
              item.alertType == 1 ||
              item.alertType == 2 ||
              item.alertType == 3 ||
              item.alertType == 16
          "
          @click="
            setDetectionText(
              wycShow ? index : item.index,
              item.words,
              item.replaceStr
            )
          "
        >
          {{ wycShow ? "采用" : "查看" }}
        </div>
      </div>
    </div>
    <div v-else>
      <el-alert
        class="alert"
        title="文章检测通过，没有发现任何问题"
        type="success"
        :closable="false"
      >
      </el-alert>
    </div>
    <!-- <div class="resultDiv">
      <p>疑似不通顺或错误字：{{ msg.length }}个</p>
      <div style="margin-top: 5px;" v-if="msg.length > 0">
        <div v-if="wycShow">
          <el-tag
            v-for="(item, index) in msg"
            :key="index"
            type="danger"
            @click="findWords(item.detectionText, item.index)"
            style="font-size: 18px; margin: 5px 10px 5px 0;cursor: pointer"
            >{{ item.detectionText }}</el-tag
          >
        </div>
        <div v-else>
          <el-tag
            v-for="(item, index) in msg"
            :key="index"
            type="danger"
            @click="findWords(item.words, item.index)"
            style="font-size: 18px; margin: 5px 10px 5px 0;cursor: pointer"
            >{{ item.words }}</el-tag
          >
        </div>
      </div>
      <div v-else>
        <el-alert
          class="alert"
          title="文章检测通过，没有发现任何问题"
          type="success"
          :closable="false"
        >
        </el-alert>
      </div>
    </div> -->
    <div class="center" style="margin-top: 10px;">
      <button :class="[timeOut > 0 ? 'btn1' : 'btn3']" @click="reset">
        {{ timeOut > 0 ? "重新检测" + "(" + timeOut + "S)" : "重新检测" }}
      </button>
    </div>
  </div>
</template>

<script>
import SearchInfo from "./SearchLoading";
import findWords from "../../assets/script/utils/findWords";
import tinymce from "tinymce";
import { SendPostData } from "../../assets/script/model";
export default {
  name: "GetErrorInfo",
  components: {
    SearchInfo
  },
  mounted() {
    this.getid = setInterval(() => {
      let getBox = document.getElementById("resultDiv");
      if (getBox) {
        clearInterval(this.getid);
      }
    }, 500);
    this.detectioncontent = setInterval(() => {
      let getBox = document.getElementById("detection-content");
      if (getBox) {
        this.fixHeight(this.contentHeight, "detection-content", 100);
        clearInterval(this.detectioncontent);
      }
    }, 500);
  },
  data() {
    return {
      check: false,
      percentage: 0,
      ptage: null,
      result: true,
      contentTime: 30,
      msg: [],
      timeOut: 0,
      addList: [],
      pNumber: 0
    };
  },
  computed: {
    wycShow: {
      get() {
        return this.$store.state.contents.wycShow;
      },
      set(val) {
        this.$store.state.contents.wycShow = val;
      }
    },
    contentCount: {
      get() {
        return this.$store.state.editorControl.contentCount;
      }
    },
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    }
  },
  watch: {
    contentHeight: {
      handler(val) {
        this.fixHeight(val, "detection-content", 165);
      }
    }
  },
  methods: {
    reset() {
      if (this.timeOut > 0) {
        this.$message({
          message: "执行一次后请休息10秒",
          type: "warning"
        });
        return;
      }
      this.result = true;
      this.$nextTick(() => {
        this.$refs.searchinfo.checkin();
      });
    },
    clearClass() {
      let getContent = tinymce.activeEditor.getBody().innerHTML;
      let reg = /<span class="proBackColor">([^>]*?)<\/span>/gi;
      let matches = [];
      while ((matches = reg.exec(getContent)) != null) {
        let innerWords = tinymce.activeEditor
          .getBody()
          .innerHTML.replace(matches[0], matches[1]);
        tinymce.activeEditor.setContent(innerWords);
      }

      getContent = tinymce.activeEditor.getBody().innerHTML;
      reg = /<span class="errBackColor">([^>]*?)<\/span>/gi;
      matches = [];
      while ((matches = reg.exec(getContent)) != null) {
        let innerWords = tinymce.activeEditor
          .getBody()
          .innerHTML.replace(matches[0], matches[1]);
        tinymce.activeEditor.setContent(innerWords);
      }

      getContent = tinymce.activeEditor.getBody().innerHTML;
      reg = /<span class="[oriBackColor1|oriBackColor2|oriBackColor3]+">([^>]*?)<\/span>/gi;
      matches = [];
      while ((matches = reg.exec(getContent)) != null) {
        let innerWords = tinymce.activeEditor
          .getBody()
          .innerHTML.replace(matches[0], matches[1]);
        tinymce.activeEditor.setContent(innerWords);
      }
    },
    findWords(words, index) {
      findWords.closeAllHighlight();
      findWords.findkeywords2(words, "error", index);
    },
    clear() {
      this.check = false;
      this.percentage = 0;
      this.ptage = null;
      this.result = true;
    },
    CheckOver(getMsg) {
      if (getMsg.ErrorCode > 0) {
        if (getMsg.ErrorCode === 200501) {
          this.insertConfig.showUpgrade(true, "获取更多使用次数");
        } else {
          this.$message({
            showClose: true,
            message: getMsg.ErrorMess,
            type: "error"
          });
        }
        return;
      }
      this.msg = [];
      this.addList = [];
      if (this.wycShow) {
        var i = 0;
        for (let item of getMsg.txt) {
          this.msg.push({
            words: item.oldStr,
            index: i,
            replaceStr: item.replaceStr,
            alertType: item.alertType,
            start: item.start,
            end: item.end,
            alertMessage: item.alertMessage
          });
          i++;
        }
      } else {
        let result = getMsg.Data.Result;

        for (let i = 0; i < result.length; i++) {
          if (result[i].length > 0) {
            for (let list of result[i]) {
              this.msg.push({
                words: list.OldStr,
                index: i,
                replaceStr: list.ReplaceStr,
                alertType: list.AlertType,
                start: list.Start,
                end: list.End,
                alertMessage: list.AlertMessage
              });
            }
          }
        }
      }
      this.timeOut = 10;
      this.result = false;
      let timeout = setInterval(() => {
        if (this.timeOut <= 0) {
          this.percentage = 0;
          clearInterval(timeout);
        } else {
          this.timeOut = this.timeOut - 1;
        }
      }, 1000);
    },
    setDetectionText(index, oldStr, replaceStr) {
      if (this.wycShow) {
        let sendData = new SendPostData();
        sendData.btn = "setDetection";
        sendData.data = {
          index: index,
          replaceStr: replaceStr,
          oldStr: oldStr
        };
        this.SendMessage(sendData);
        this.msg = this.msg.filter(m => {
          if (m.alertType == 3 || m.alertType == 16) {
            return m.words != oldStr;
          } else {
            if (m.replaceStr && m.alertType == 4) {
              return m.words != oldStr && m.replaceStr != replaceStr;
            }
          }
        });
      } else {
        findWords.closeAllHighlight();
        findWords.findkeywords2(oldStr, "error", index);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/mixin";
* {
  font-size: 12px;
}
.alert {
  margin-top: 35px;
  width: 250px;
  margin-left: 100px;
}
.d1 {
  line-height: 30px;
  margin-top: 5px;
  padding: 0 15px;
}
.resultDiv {
  padding: 5px 10px;
  border: 1px solid #d3d7de;
  margin: 15px 10px;
  min-height: 150px;
}
.btn {
  background-color: #0f58f5;
  padding: 3px 9px;
  color: #fff;
  border: 1px solid #0f58f5;
  border-radius: 10px;
  cursor: pointer;
  margin-right: 8px;
}
.btn1 {
  .btn();
  color: #fff;
  background-color: #888888;
  border: 0;
  padding: 5px 15px;
}
.btn3 {
  .btn;
  padding: 5px 15px;
  background-color: #167df3;
}
.detection-box {
  margin: 15px 15px 10px;
  border: 1px solid #d4d8e0;
  border-radius: 3px;
  padding: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-left: 4px solid #ff9292;
  .detection-text {
    font-size: 16px;
    font-weight: bolder;
    margin-right: 15px;
    color: #666;
    .rownumber(1);
  }
  .detection-subtext {
    color: #999;
    margin-right: 15px;
  }
  .detection-left {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .detection-right {
    color: #124db1;
    font-weight: bold;
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
